"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _core = require("@material-ui/core");

var _withWidth = _interopRequireWildcard(require("@material-ui/core/withWidth"));

var _utils = require("../../utils");

var _Button = _interopRequireWildcard(require("../../elements/Button"));

var _Typography = _interopRequireDefault(require("../../elements/Typography"));

var _FormModal = _interopRequireDefault(require("./FormModal.css"));

var FormModal =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(FormModal, _React$PureComponent);

  function FormModal() {
    (0, _classCallCheck2.default)(this, FormModal);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormModal).apply(this, arguments));
  }

  (0, _createClass2.default)(FormModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          open = _this$props.open,
          fullScreen = _this$props.fullScreen,
          title = _this$props.title,
          description = _this$props.description,
          actions = _this$props.actions,
          width = _this$props.width;
      return React.createElement(_Dialog.default, {
        open: open,
        fullScreen: fullScreen || !(0, _withWidth.isWidthUp)('sm', width),
        PaperProps: {
          classes: {
            root: classes.root
          }
        },
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description"
      }, React.createElement(_DialogTitle.default, {
        id: "alert-dialog-title",
        className: classes.title
      }, (0, _utils.isTextContent)(title) ? React.createElement(_Typography.default, {
        variant: 'dialogHeader'
      }, title) : title), React.createElement(_DialogContent.default, {
        className: classes.content
      }, (0, _utils.isTextContent)(description) ? React.createElement(_Typography.default, {
        variant: 'dialogContent'
      }, description) : description, React.createElement(_DialogContent.default, {
        className: classes.content
      }, children)), React.createElement(_DialogActions.default, {
        className: classes.actions
      }, actions.map(function (_ref) {
        var type = _ref.type,
            action = _ref.action,
            label = _ref.label;
        return React.createElement(_Button.default, {
          key: label,
          type: type,
          onClick: action
        }, label);
      })));
    }
  }]);
  return FormModal;
}(React.PureComponent);

FormModal.defaultProps = {
  fullScreen: false,
  description: ''
};
FormModal.propTypes = {
  /**
   * 	If true, the Dialog is open
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * If true, the dialog will be full-screen
   */
  fullScreen: _propTypes.default.bool,

  /**
   * Title of the form dialog
   */
  title: _propTypes.default.node.isRequired,

  /**
   * Short description of the form
   */
  description: _propTypes.default.string,

  /**
   * Form body to be rendered
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Set of possible actions form will respond to
   */
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.node.isRequired,
    type: _propTypes.default.oneOf(Object.values(_Button.BUTTON_TYPES)),
    action: _propTypes.default.func.isRequired
  })).isRequired
};

var _default = (0, _utils.compose)((0, _core.withStyles)(_FormModal.default), (0, _withWidth.default)())(FormModal);

exports.default = _default;